export const CREATE_EMAIL_CREDENTIAL = 'CREATE_EMAIL_CREDENTIAL';
export const CREATE_EMAIL_CREDENTIAL_SUCCESS = 'CREATE_EMAIL_CREDENTIAL_SUCCESS';
export const CREATE_EMAIL_CREDENTIAL_FAILED = 'CREATE_EMAIL_CREDENTIAL_FAILED';

export const GET_EMAIL_CREDENTIAL = 'GET_EMAIL_CREDENTIAL';
export const GET_EMAIL_CREDENTIAL_SUCCESS = 'GET_EMAIL_CREDENTIAL_SUCCESS';
export const GET_EMAIL_CREDENTIAL_FAILED = 'GET_EMAIL_CREDENTIAL_FAILED';

export const UPDATE_EMAIL_CREDENTIAL = 'UPDATE_EMAIL_CREDENTIAL';
export const UPDATE_EMAIL_CREDENTIAL_SUCCESS = 'UPDATE_EMAIL_CREDENTIAL_SUCCESS';
export const UPDATE_EMAIL_CREDENTIAL_FAILED = 'UPDATE_EMAIL_CREDENTIAL_FAILED';

export const DELETE_EMAIL_CREDENTIAL = 'DELETE_EMAIL_CREDENTIAL';
export const DELETE_EMAIL_CREDENTIAL_SUCCESS = 'DELETE_EMAIL_CREDENTIAL_SUCCESS';
export const DELETE_EMAIL_CREDENTIAL_FAILED = 'DELETE_EMAIL_CREDENTIAL_FAILED';